/*
 * This class is passed throughout the react components and stores information from the
 * overall MIP csv file. Changes are brought over automatically from a series of csv -> json
 * python scripts.
 */
class PactUser {
  constructor() {
    this.projectName = "";
    this.projectNature = null;
    this.urgency = false;
    this.DBS = false;
    this.EstCosts = "";
    this.scenarioGroup = 1;
    this.scenarioChoice = "";
    this.pathwayChoice = "SWP";
    this.contractRecommendation = [];
    this.contractNotRecommended = [];
    this.firstLoad = true;
    this.tailoringOptions = {};
    this.tailoringChoice = {};

    this.UCATips = require("../dataIngest/Tips/UCA.json");
    this.DBSTips = require("../dataIngest/Tips/DBS.json");
    this.MCATips = require("../dataIngest/Tips/MCA.json");
    this.MTA_RFTips = require("../dataIngest/Tips/MTA_RF.json");
    this.MTA_RPTips = require("../dataIngest/Tips/MTA_RP.json");
    this.SWPTips = require("../dataIngest/Tips/SWP.json");
    this.AOSTips = require("../dataIngest/Tips/AOS.json");

    this.yesPathways = [];
    this.noPathways = [];
    this.NAPathways = [];

    this.printOptions = {
      pathway: true,
      approach: true,
      contract: true,
      tailor: true,
    };

    this.natureDescriptions = {
      NAT1: "Prototyping a promising technology for integration into a program of record",
      NAT2: "Prototyping a promising technology to deploy a minimum operational capability",
      NAT3: "Fielding a commercial or mature technology to meet a specific operational need",
      NAT4: "Development of or upgrade to a hardware platform or sensor",
      NAT5: "Development of software upgrades for an existing weapons platform",
      NAT6: "Development of software to be fielded or upgraded using commercial hardware",
    };

    /***
     *
     * Pathway Information
     *
     **/

    this.fullPathwayNames = {
      MCA: "Major Capability Acquisition (MCA) Pathway",
      UCA: "Urgent Acquisition (UCA) Pathway",
      RapidFielding:
        "Middle Tier of Acquisition – Rapid Fielding (MTA-RF) Pathway",
      RapidPrototyping:
        "Middle Tier of Acquisition – Rapid Prototyping (MTA-RP) Pathway",
      DBS: "Defense Business Systems (DBS) Pathway",
      SWP: "Software Acquisition (SWP) Pathway",
      AOS: "Acquisition of Services",
    };

    // Pathways applicable to each group
    this.pathwayDict = {
      1: {
        Yes: ["MCA", "SWP"],
        No: ["RapidPrototyping"],
        NA: ["UCA", "DBS", "RapidFielding"],
      },
      2: {
        Yes: ["MCA", "SWP", "RapidPrototyping"],
        No: [""],
        NA: ["UCA", "DBS", "RapidFielding"],
      },
      3: {
        Yes: ["MCA", "SWP", "RapidPrototyping"],
        No: [""],
        NA: ["UCA", "DBS", "RapidFielding"],
      },
      4: {
        Yes: ["SWP"],
        No: ["RapidPrototyping"],
        NA: ["UCA", "MCA", "DBS", "RapidFielding"],
      },
      5: {
        Yes: ["SWP", "RapidPrototyping"],
        No: [""],
        NA: ["UCA", "MCA", "DBS", "RapidFielding"],
      },
      6: {
        Yes: ["MCA", "SWP", "RapidPrototyping"],
        No: [""],
        NA: ["UCA", "DBS", "RapidFielding"],
      },
      7: {
        Yes: ["MCA", "SWP", "RapidFielding"],
        No: [],
        NA: ["UCA", "RapidPrototyping", "DBS"],
      },
      8: {
        Yes: ["MCA", "SWP", "RapidFielding"],
        No: [],
        NA: ["UCA", "RapidPrototyping", "DBS"],
      },
      9: {
        Yes: ["MCA", "SWP", "RapidFielding"],
        No: [],
        NA: ["UCA", "RapidPrototyping", "DBS"],
      },
      10: {
        Yes: ["UCA", "MCA", "SWP", "RapidFielding"],
        No: [],
        NA: ["RapidPrototyping", "DBS"],
      },
      11: {
        Yes: ["UCA", "MCA", "SWP", "RapidFielding"],
        No: [],
        NA: ["RapidPrototyping", "DBS"],
      },
      12: {
        Yes: ["SWP", "DBS"],
        No: [],
        NA: ["UCA", "MCA", "RapidFielding", "RapidPrototyping"],
      },
      13: {
        Yes: ["SWP", "DBS"],
        No: [],
        NA: ["UCA", "MCA", "RapidFielding", "RapidPrototyping"],
      },
      14: {
        Yes: ["SWP", "DBS"],
        No: [],
        NA: ["UCA", "MCA", "RapidFielding", "RapidPrototyping"],
      },
      15: {
        Yes: ["MCA"],
        No: ["RapidFielding", "RapidPrototyping"],
        NA: ["UCA", "DBS", "SWP"],
      },
      16: {
        Yes: ["MCA", "RapidPrototyping"],
        No: [],
        NA: ["UCA", "RapidFielding", "DBS", "SWP"],
      },
      17: {
        Yes: ["MCA", "RapidPrototyping"],
        No: [],
        NA: ["UCA", "RapidFielding", "DBS", "SWP"],
      },
      18: {
        Yes: ["UCA", "MCA", "RapidPrototyping"],
        No: [],
        NA: ["RapidFielding", "DBS", "SWP"],
      },
      19: {
        Yes: ["UCA", "MCA", "RapidPrototyping"],
        No: [],
        NA: ["RapidFielding", "DBS", "SWP"],
      },
      20: {
        Yes: ["MCA", "SWP", "RapidPrototyping"],
        No: [],
        NA: ["UCA", "RapidFielding", "DBS"],
      },
      21: {
        Yes: ["MCA", "SWP", "RapidPrototyping"],
        No: [],
        NA: ["UCA", "RapidFielding", "DBS"],
      },
      22: {
        Yes: ["MCA", "SWP", "RapidPrototyping"],
        No: [],
        NA: ["UCA", "RapidFielding", "DBS"],
      },
      23: {
        Yes: ["UCA", "SWP", "RapidPrototyping"],
        No: ["MCA"],
        NA: ["RapidFielding", "DBS"],
      },
      24: {
        Yes: ["UCA", "SWP", "RapidPrototyping"],
        No: ["MCA"],
        NA: ["RapidFielding", "DBS"],
      },
      25: {
        Yes: ["SWP", "RapidPrototyping"],
        No: ["MCA"],
        NA: ["UCA", "RapidFielding", "DBS"],
      },
      26: {
        Yes: ["SWP", "RapidPrototyping"],
        No: ["MCA"],
        NA: ["UCA", "RapidFielding", "DBS"],
      },
      27: {
        Yes: ["SWP", "RapidPrototyping"],
        No: ["MCA"],
        NA: ["UCA", "RapidFielding", "DBS"],
      },
      28: {
        Yes: ["UCA", "SWP", "RapidPrototyping"],
        No: ["MCA"],
        NA: ["RapidFielding", "DBS"],
      },
      29: {
        Yes: ["UCA", "SWP", "RapidPrototyping"],
        No: ["MCA"],
        NA: ["RapidFielding", "DBS"],
      },
      30: {
        Yes: ["SWP", "DBS"],
        No: ["MCA", "RapidFielding", "RapidPrototyping"],
        NA: ["UCA"],
      },
      31: {
        Yes: ["SWP", "DBS"],
        No: ["MCA", "RapidFielding", "RapidPrototyping"],
        NA: ["UCA"],
      },
      32: {
        Yes: ["SWP", "DBS"],
        No: ["MCA", "RapidFielding", "RapidPrototyping"],
        NA: ["UCA"],
      },
    };

    this.pathwayInformation = require("../dataIngest/Pathways/pathway.json");

    /***
     *
     * Contract Information
     *
     **/

    this.contractInformation = require("../dataIngest/contract/contract.json");
    this.contractNames = Object.keys(this.contractInformation);
    this.contractAbbrev = [
      "FAR84",
      "FAR12",
      "FAR13",
      "FAR15",
      "IDIQ",
      "FAR1603",
      "FAR167",
      "FAR19",
      "BAA",
      "STTR",
      "CSO",
      "OTS",
      "EXPERIMENT",
      "CRADA",
      "PIA",
      "TIA",
    ];

    this.contractReference = {
      FAR84: "(FAR Part 8.4)",
      FAR12: "(FAR Part 12)",
      FAR13: "(FAR Part 13)",
      FAR15: "(FAR Part 15)",
      IDIQ: "(FAR Part 16.5)",
      FAR1603: "(FAR PART 16.603)",
      FAR167: "(FAR Part 16.7)",
      FAR19: "(FAR Part 19)",
      BAA: "(FAR Part 35.016)",
      STTR: "",
      CSO: "",
      OTS: "",
      EXPERIMENT: "(10 U.S.C. §2373)",
      CRADA: "(15 U.S.C. §3710a)",
      PIA: "(15 U.S.C. §3715)",
      TIA: "(32 CFR Part 37)",
    };

    this.fullContractNames = {
      FAR84: "Federal Supply Schedules",
      FAR12: "Commercial Items",
      FAR13: "Simplified Acquisitions",
      FAR15: "Contracting by Negotiation",
      IDIQ: "Indefinite Delivery Indefinite Quantity (IDIQ)",
      FAR1603: "Letter Contract",
      FAR167: "Agreements",
      FAR19: "Small Business",
      BAA: "Broad Agency Announcement (BAA)",
      STTR: "Small Business Innovation Research (SBIR) / Small Business Technology Transfer (STTR)",
      CSO: "Defense Commercial Solutions Opening (CSO)",
      OTS: "Other Transactions (OTS)",
      EXPERIMENT: "Procurement for Experimental Purposes",
      CRADA: "Cooperative Research and Development Agreement (CRADA)",
      PIA: "Partnership Intermediary Agreement (PIA)",
      TIA: "Technology Investment Agreement (TIA)",
    };

    // *** Needs an updated script to pull this from csv automatically
    // *** Previous script invalid as file format changed considerably since this info was pulled
    // *** Info itself is current though
    this.contractDescriptions = {
      Summary: {
        FAR84: {
          description: [
            "Simplified ordering process for commercial supplies and services at prices associated with volume buying. " +
              "GSA Schedules contain negotiated fixed-prices for products and hourly-rates for services offered by each contractor.",
          ],
          bullets: [],
        },
        FAR12: {
          description: [
            "Supplies and services that meet the definition of a commercial item at FAR Part 2.1. Non-Developmental Item (NDI) and " +
              "Commercial Off-the-Shelf (COTS) are considered subsets of commercial items.",
          ],
          bullets: [],
        },
        FAR13: {
          description: [
            "Streamlined processes to acquire supplies and services, including construction, research and development, and commercial" +
              " items, for which the aggregate amount does not exceed the simplified acquisition threshold (SAT). (See definition of SAT at FAR Part 2.1)",
            "Strategies include Blanket Purchase Agreement (BPA), Purchase Order (PO), and micro-purchases.",
          ],
          bullets: [],
        },
        FAR15: {
          description: [
            "Procedures for competitive and non-competitive open market acquisitions exceeding the Simplified Acquisition Threshold (SAT).",
          ],
          bullets: [],
        },
        IDIQ: {
          description: [
            "Method to order from existing organziation indefinite-delivery contracts as well as contracts awarded by another agency" +
              " (i.e. Government-wide Acquisition Contracts (GWACs) and Multi-Agency Contracts (MACs)).",
            "GWAC: task-order or delivery-order contract for IT for Government-wide use. The Economy Act does not apply to GWAC orders.",
            "MAC: task-order or delivery-order contract for supplies and services or IT for Government-wide use. The Economy Act applies" +
              "to MAC orders, with exception of MACs for IT covered by Clinger-Cohen Act.",
            "Establishing a new single or multiple award IDIQ contract may be an appropriate business" +
              " decision to support a portfolio of programs within an organization when recurring needs are anticipated.",
          ],
          bullets: [],
        },
        FAR1603: {
          description: [
            "A means to authorize a contractor to immediately begin work before the terms and conditions of the contract can be" +
              "agreed upon, used only when negotiating a definitive contract is not possible in sufficient time to meet the requirement and " +
              "the Government’s interest demands that the Contractor start immediately.",
            "Also known as Undefinitized Contract Action (UCA).",
          ],
          bullets: [],
        },
        FAR167: {
          description: [
            "Basic Agreement: Contemplates separate future contracts; descriptions of supplies or services to be provided; and/or methods " +
              "for pricing, issuing, and delivering future orders that will incorporate the required and applicable clauses agreed upon in the basic agreement.",
            "Basic Ordering Agreement: A written instrument of understanding (not a contract) containing pre-negotiated contract clauses that will be applicable" +
              " to future procurements between the parties during the term of the agreement. Includes a description of the product or services and the method for" +
              "determining pricing, issuing, and delivering of future orders.",
          ],
          bullets: [],
        },
        FAR19: {
          description: [
            "Small Business Set-Asides are a method to reserve a total acquisition or a portion of an acquisition exclusively for small businesses.",
            "Qualifying small business concerns include one or more of the following categories:",
          ],
          bullets: [
            "Small Business",
            "Service–Disabled Veteran-Owned Small Business",
            "Historically Underutilized Business Zone (HUBZone) Small Business",
            "Women-Owned Small Business",
            "Small Disadvantaged Business (8(a) Business Development Program",
          ],
        },
        BAA: {
          description: [
            "Used to obtain proposals for basic and applied research and development to advance or evaluate cutting edge technologies," +
              " not related to a specific system or hardware requirement.",
            "BAAs may be used for the award of science and technology proposals for the following: ",
          ],
          bullets: [
            "Basic research (budget activity 6.1)",
            "Applied research (budget activity 6.2)",
            "Advanced technology development (budget activity 6.3)",
            "Advanced component development and prototypes (budget activity 6.4) ",
          ],
        },
        STTR: {
          description: [
            "SBIR  is a competitive program that encourages small businesses to engage in federal F&D with the potential" +
              "for commercialization to stimulate innovation. ",
            "STTR is another program to facilitate cooperative R&D between small business concerns and non-profit/US research institutions with the" +
              "potential for commercialization of innovative technological solutions.",
            "SBIR/STTR program funds Phase I and II awards; programs must directly fund Phase III awards.",
          ],
          bullets: [],
        },
        CSO: {
          description: [
            "Used to obtain solutions or new capabilities that fulfill requirements, close capability gaps," +
              " or provide potential technological advances. ",
            "CSO procedures are similar to those for Broad Agency Announcements (BAAs), with the exception" +
              " that a CSO can be used to acquire innovative commercial items, technologies, or services that directly meet program requirements. ",
          ],
          bullets: [],
        },
        OTS: {
          description: [
            "Research OTs: appropriate for basic, applied, and advanced research projects related to weapons systems or" +
              "other military needs. May be used to pursue research and development of technology with dual-use application (commercial and government).",
            "Prototype OTs: appropriate for research and development and prototyping activities to enhance mission effectiveness" +
              " of military personnel and supporting platforms, systems, components, or materials. May be used to acquire a reasonable" +
              " number of prototypes to test before making a decision to purchase in quantity.",
          ],
          bullets: [],
        },
        EXPERIMENT: {
          description: [
            "Authorizes the government to acquire quantities necessary for experimentation," +
              " technical evaluation, assessment of operational utility, or to maintain a residual operational capability." +
              " This authority currently allows for acquisitions in the following nine areas: Ordnance, Signal, Chemical Activity," +
              " Transportation, Engery, Medical, Space-Flight, Aeronautical Supplies, Telecommunications.",
          ],
          bullets: [],
        },
        CRADA: {
          description: [
            "Authorizes federal labs to enter into agreements with other federal agencies, state/local government, industry, non-profits," +
              " and universities for licensing agreements for lab developed inventions or intellectual property to commercialize products or" +
              "processes originating in federal labs.",
          ],
          bullets: [],
        },
        PIA: {
          description: [
            "Contract, agreement, or memorandum of understanding with non-profit partnership intermediary to engage academia" +
              " and industry on behalf of government to accelerate tech transfer and licensing.",
          ],
          bullets: [],
        },
        TIA: {
          description: [
            "An instrument used to stimulate or support commercial firm involvement in pursuing best technologies" +
              " for defense research. TIAs are appropriate when research objectives are unlikely to be achieved using other types of contract instruments.",
            "May be executed as a cooperative agreement or a type of assistance transaction other than a grant or cooperative agreement, such as a" +
              " Research Other Transaction (OT) – 10 U.S.C. §2371.",
          ],
          bullets: [],
        },
      },
      Benefit: {
        FAR84: [
          "Pre-negotiated prices already determined fair and reasonable and GSA streamlined procedures.",
          "Can negotiate further price discounts from established schedule rates.",
        ],
        FAR12: [
          "Leveraging commercial market pricing data reduces administrative cost and procurement lead time.",
          "Streamlined procedures for commercial technologies provides opportunity to acquire and deliver capability quickly.",
        ],
        FAR13: [
          "Streamlined procedures reduce lead time to award.",
          "BPAs with multiple vendors maintains competition and reduces cost, schedule, and performance risk associated with a single vendor source.",
        ],
        FAR15: [
          "Flexibility to design and negotiate solutions that meet mission requirements from basic to large scale, complex acquisitions.",
          "Ability to uniquely negotiate terms and conditions, and pricing arrangements.",
        ],
        IDIQ: [
          "Pre-negotiated prices and labor rates reduces procurement lead time and provides opportunity for further negotiated price discounts.",
          "Streamlined ordering procedures offered by existing contracts.",
          "Access to pre-vetted, qualified contractors.",
          "Generally easier to close out an order than a separate contract.",
          "If the customer is not satisfied with the deliveries, future tasks do not have to be awarded on the IDIQ.",
          "Can extend the ordering period under certain circumstances, and orders can be placed on the last day of the ordering period without delivery having to be completed by the end of the ordering period.",
        ],
        FAR1603: [
          "Provides immediate authority to proceed to rapidly meet urgent mission requirements.",
        ],
        FAR167: [
          "Ability to on-ramp new agreement holders any time.",
          "No ceiling; pricing determined at order level.",
          "No government commitment to guarantee orders.",
          "Latitude for determining order award criteria - best value/tradeoff, price/past performance, or LPTA evaluations authorized at order level",
          "Gov can modify or cancel agreements at any time.",
        ],
        FAR19: [
          "Provide maximum opportunity to use small businesses in acquisition",
          "Provide opportunities to small businesses grow the industrial base and strengthen the economy.",
          "Small businesses provide culture of flexibility and innovation offering acquisition programs unique solutions to solving capability gaps",
          "Ability to award directly to an 8(a) program qualifying vendor within FAR threshold.",
        ],
        BAA: [
          "Increases knowledge in areas of strategic importance and technical capability to programs.",
          "Streamlined evaluation process based on technical merit increases flexibility to select innovative capability solutions.",
        ],
        STTR: [
          "Ability to award sole source contracts to SBIR Phase I/Phase II vendors for Phase III work reduces procurement lead time.",
          "SBIR/STTR programs seek to fund small business with promising capabilities to develop and pursue commercialization.",
        ],
        CSO: [
          "Enables rapid selection of innovative commercial solutions.",
          "Can use streamlined procedures for commercial technologies.",
          "Shorter evaluation timelines for solution briefs significantly reduce procurement lead times",
        ],
        OTS: [
          "Prototype OTs provide a streamlined path to award a non-competitive follow-on Production OT or Production FAR contract.",
          "Offer flexible approach to terms & conditions and managing intellectual property, enabling greater access to commercial innovators that do not comply with traditional government data rights.",
          "FAR and DFARS are N/A.",
        ],
        EXPERIMENT: [
          "1. Potential to use this authority to procure higher quantities of supplies; definitions in statutory language can be broadly interpreted.",
          "Can be executed quickly and non-competitively.",
          "Can be “stacked” with other statutory authorities if long-term, critical thinking is applied to acquisition strategy.",
        ],
        CRADA: [
          "1. Can be adapted to a variety of types of collaborative efforts between federal and non-federal organizations to transfer federally funded R&D to private sector",
          "Enables industry to collaborate with government to jointly research and develop technologies with both commercial and military applications.",
        ],
        PIA: [
          "Partnership intermediaries can function as objective third-party brokers between government and industry to increase opportunity for commercialization of new capability.",
          "Partnership intermediaries can engage in proactive marketing of lab technologies to industry to enable tech transition/tech insertion.",
          "Enables Government to pay for services to support technology transfer.",
        ],
        TIA: [
          "1. Fosters research of best technologies for future defense needs.",
          "May be expenditure-based or fixed-support (32 CFR §37.300).",
        ],
      },
      Downside: {
        FAR84: [
          "Limited to firm-fixed-price (FFP) or time and materials (T&M) pricing arrangements.",
          "Standard schedule commercial rights and licenses increases burden on government to ensure any specialized rights are explicit.",
        ],
        FAR12: [
          "Inability to tailor to unique government requirements (e.g. product customization)",
          "Application of standard commercial rights and licenses increases burden on government to ensure any specialized rights are explicit.",
          "Limited to firm-fixed-frice (FFP), fixed-price with economic price adjustment (FPEPA), and time-and-materials (T&M) contract types.",
        ],
        FAR13: [
          "Simplified acquisition threshold limitation reduces flexibility to acquire large scale orders.",
        ],
        FAR15: [
          "Traditionally have a longer procurement lead time to award.",
          "Procedures require labor intensive government resource support increasing administrative burden and costs.",
        ],
        IDIQ: [
          "Orders above FAR threshold are protestable.",
          "Conditions and scope limitations (work scope, ceiling, and period of performance) may limit flexibility.",
          "Orders that are not fully priced at the time the IDIQ is issued can require as much effort to award as a new contract.",
          "Point of confusion: Fair Opportunity Exceptions are not identical to sole source justifications under FAR Part 6 (such as National Security or classified orders on IDIQs).",
        ],
        FAR1603: [
          "Undefined terms and conditions and limited ability to control cost increases risk to the Government.",
          "Elevated level of approvals, oversight, and reporting requirements during contract definitization process increases burden on program and contracting office.",
        ],
        FAR167: [
          "No obligation by contractor to provide services until pricing established at time of order.",
          "No established price list; only a method of establishing pricing at time of order.",
          "May be changed only by modifying agreement itself, not by a contract incorporating the agreement.",
        ],
        FAR19: [
          "Many small businesses do not have approved cost accounting systems limiting selection of contract types",
          "Many small businesses are on a tight budget and cannot hold together proposed teams for extended periods of time, making it more important for the Government to award contracts faster.",
        ],
        BAA: [
          "Limitations on use of BAAs increases burden on government to transition capability to acquisition programs.",
          "Intellectual property and data rights increases burden on government to ensure rights are explicit during transition to acquisition programs.",
          "Cannot acquire products in quantity as the focus is on research and knowledge rather than supplies.",
          "Fiscal law requires that RDT&E funding be used for BAAs.",
        ],
        STTR: [
          "SBIR/STTR program data rights protection limits Government’s IP strategy.",
          "Programs must independently develop strategies to insert/transition SBIR/STTR solutions into program of record.",
          "Language used in proposal instructions and requirements to award a contract vary among agencies.",
        ],
        CSO: [
          "Data rights and licensing of commercial technology increases burden on government to ensure any requirements for specialized rights are well understood within the context of the commercial product life cycle.",
          "Limited to fixed-price or fixed-price incentive contracts.",
        ],
        OTS: [
          "Government assumes increased risks without the process, precedent, and built-in protections of the FAR.",
          "Contracting Officer must have Agreements Officer authority to execute and the buying office must have authority under 10 USC 2371 to award an OT for Research and authority under 10 USC 2371b to award an OT for Prototype or Production.",
          "Pursuit and execution of an OT requires experienced and empowered staff.",
          "Although FAR and DFARS do not apply, statutes not specifically called out in 10 USC 2371 and 2371b (such as security/classification) still apply.",
        ],
        EXPERIMENT: [
          "Pursuit and execution of this authority requires experienced and empowered staff.",
          "Contracting Officer must have Agreement Officer authority to execute and the buying office must have authority.",
          "Lack of guidance and established precedent increases risk to the government.",
          "May not be used as a predecessor to an Other Transactions for Production; currently only a successfully completed Other Transaction for Prototype may transition to an Other Transaction for Production.",
          "Lack of guidance and experience may result in policy reviewers and approvers being uneasy and requiring extraneous layers of oversight.",
        ],
        CRADA: [
          "Authority limited to government owned or government owned, contractor operated labs.",
          "Government may contribute wide variety of resources, but no funds.",
          "Contracting Officer must have Agreements Officer authority to execute",
        ],
        PIA: [
          "Authority limited to government labs.",
          "Contracting Officer must have Agreements Officer authority to execute.",
        ],
        TIA: [
          "Requires knowledgeable and skilled contracting officer to negotiate and execute.",
          "Must justify using TIA rather than another type of contract instrument",
          "Requires delegated authority from SECDEF or Service Secretary",
          "Contracting Officer must have Agreements Officer authority to execute.",
        ],
      },
      tips: {
        FAR84: [
          "Agencies can place Task Orders (Services) or Delivery Orders (Supplies) under GSA Federal Supply Schedules or establish Blanket Purchase Agreements " +
            "(BPAs), with a single schedule contractor or with multiple schedule contractors for the same supplies or services.",
        ],
        FAR12: [
          "DFARS Part 212.102(a)(iii) further expands the application of commercial item procedures to supplies and services from non-traditional defense contractors " +
            "to enhance defense innovation and investment and encourage non-traditional vendors to do business with the government. A commercial item determination is not required.",
        ],
        FAR13: [
          "FAR 13.5 authorizes the use of simplified procedures for the acquisition of supplies and services in amounts greater than the simplified acquisition threshold but " +
            "not exceeding $7.5 million ($15 million for acquisitions as described in 13.500(c)), including options, if the contracting officer reasonably expects that offers will include only commercial items.",
        ],
        FAR15: [
          "Competitive range or multi-step award process provides time saving mechanism to negotiate with only highest-rated vendor offers.",
          "Consider using Part 35 BAA procedures instead to procure research via streamlined solicitation and evaluation procedures.",
        ],
        IDIQ: [
          "Section 825 of FY17 NDAA modified the requirement to consider price or cost as an evaluation factor for the award of certain multiple-award task-order contracts. " +
            "Solicitations for multiple-award contracts that will be awarded for the same or similar services AND state the Government intends to award a contract to each qualifying " +
            "offeror do not require price or cost as an evaluation factor for IDIQ contract award. Price or cost will be evaluated as a factor for award of each order.,",
          "The more fully pre-priced at award of IDIQ, the faster orders can be awarded.   However, if all prices are not available at time of IDIQ award or prices are seldom-required items are " +
            "not available at the time of award, these can be added to the IDIQ via modification while unrelated orders are ongoing.",
          "Attach pricing/ordering information to the contract as a separate document rather than including within the contract to make it easier to redact when necessary for FOIA requests. ",
          'IDIQs can be awarded from different "pools" of vendors, based on early determinations of which work can be awarded within certain pools.  These pools could be based on socio-economic' +
            "status or technology areas.",
          "IDIQs can include options or phases within each order, including option years for each order with separate pricing.",
          "Acquisition strategy documentation can be produced at the IDIQ level instead of the order level or at the individual order level but should be documented that it covers all orders if " +
            "done only at the IDIQ level.",
          "Although multiple-award IDIQs are preferred, a single-award IDIQ may be more effective if the work cannot be easily segregated or needs to be integrated seemlessly.",
          'IDIQs are an exceptional way to "batch" recurring types of work (such as demos), contractors (only 3 vendors with security access),  and contractors who produce supplies for Foreign ' +
            "Military Sales (each contractor has multiple items that can be ordered by different nations); therefore, it's a staple in setting up a strategic sourcing portfolio within " +
            "a buying office",
        ],
        FAR1603: [
          "Must be definitized by 180 days or before completion of 40% of work. Under a UCA, 180 days begins with the contractor's submission of a qualifying proposal; otherwise it is interpretted " +
            "as 180 days from issuance of the letter contract.",
          "A contract may be funded at a higher rate if/when the contractor provided a qualifying proposal.",
          "Obligation of 100% funds is generally not permitted except in rare circumstances, such as expiring funding, due to loss of negotiating leverage. Obligations above 75% must have " +
            "been approved at higher levels",
          "Contracting Officers can unilaterally definitize a contract if negotiations stall but should be prepared for conflict.",
          "Contracting Officers can utilize a strategy of reducing profit on a UCA as more time drags on and more work is completed, thereby reducing risk which is tied to profit.",
          "If a UCA cannot be definitized within 180 days, the Contracting Officer can break the 180 schedule set forth in the issuance of the UCA under specific circumstances. " +
            "The 180 days is generally considered a hard requirement but it can and is broken occastionally, usually because some contractors try to force the Contracting Officer to " +
            "settle rather than have to report breaking 180 days, thereby creating a bad settlement for the Government.",
        ],
        FAR167: ["NA"],
        FAR19: [
          "Class Deviation 2020-O0009, implementing Section 823 of the FY20 NDAA authorizes sole source 8(a) awards valued at $100 million or less without a justification and approval. ",
        ],
        BAA: [
          "BAAs may be used to award FAR-based contracts, grants, or statutory agreements including Other Transactions for Research or for Prototype.",
          'BAAs may include multiple topics, sometimes called "omnibus BAAs," and be open for extended periods (usually renewable yearly) or with mutliple due dates, multi-step (white paper ' +
            'and inivitation to submit proposal), and can be used for "mini-source selections" via amendments to the BAA, calls against the BAA, or as a catch-all for what might otherwise be ' +
            "submitted as unsolicited proposals.  BAAs are highly customizable.",
        ],
        STTR: [
          "Agencies may enter into a Phase III SBIR contracts, grants, or Other Transaction agreements at any time (competitively or non-competitively) with a Phase I or Phase II awardee.",
          "Although agencies primarily use procurement contracts, grants, or agreements in the SBIR program, the use of Other Transactions (OTs) as award instruments is authorized. Section " +
            "863-864 of the FY18 NDAA includes express authority to allow for the award of Prototype OTs in the SBIR program.",
          "Lower dollar Phase I contracts can be awarded as purchase orders to streamline the process.",
        ],
        CSO: [
          "Innovation under a CSO is broad and defined as any new technology, process, or method.",
          "Can be used to acquire R&D solutions from component development through operational systems development.",
          "Program should ensure any specialized rights are well understood within the context of the commercial product life cycle.",
          'CSOs can be written similiarly to BAAs as an "omnibus CSO" or open CSO to provide more flexibility for proposals and awards.',
          "CSOs can result in Other Transactions for Prototype for research but can transition to Other Transactions for Production as a result of the CSO.",
          "CSOs are highly customizable, similar to BAAs, and could remain open for an extended period of time for vendors to provide solutions, such as for IT intensive efforts.",
        ],
        OTS: [
          "Although the Competition in Contracting Act (CICA) is not applicable to OTs, competition should be pursued to the maximum extent practicable to incentivize high quality and " +
            "competitive pricing. Additionally, competitive procedures are required in order to leverage the authority for transition to follow-on production contracts or transactions " +
            "without subsequent competition.",
          'OTs can be combined with other authorities such as CSO, SBIR/STTR, and Procurement for Experimental Purposes as well as "stacked" with FAR solicitations such as BAAs or Part ' +
            "15 Requests for Proposal.",
          "Although OTs tend to be more streamlined than FAR contracts, documentation is still smart. It may be important to defend a decision, to inform a successors, or to transition to a " +
            "new Adaptive Acquisition Pathway or to a FAR production contract.  Documentation does not have to be extensive.",
          "If the follow-on OT for Production will require an integrator, the government should decide prior to the OT for Prototype whether the integrator will be the government, one of the " +
            "OT for Propotype performers, an independent integrator, or some other course of action.",
          "The OT for Prototype agreement should have exit criteria which may be the same as success criteria to transition to an OT for Production.  This criteria can  be written to allow " +
            "transition of successful parts of the OT for Prototype to transition to an OT for Production even if the entire OT for Protype is not yet complete, based on successful completion of " +
            "key technical goals, success metrics incorporated into the agreement, or  accomplishment of a particularly favorable or unexpected results that justify the transition to production.",
        ],
        EXPERIMENT: [
          "Can be competitive or non-competitive and awarded using a contract or agreement.",
          "FAR and DFARS are not applicable; therefore, formal competitive procedures do not apply and any resultant contract is not required to include standard provisions and clauses required " +
            "by procurement laws. Instead, a contract could be written using commercial terms.",
          "Another option is to use an Other Transaction-like agreement, similar to the agreements written under the authority of 10 U.S.C. §2371 or 10 U.S.C. §2371b.",
          'CSO may be used as a solicitation, particularly as an "omnibus" CSO open for an extended period of time, with awards under 10 USC 2373.  This technique is especially useful for ' +
            "IT solutions (telecommunications).",
        ],
        CRADA: ["NA"],
        PIA: ["NA"],
        TIA: [
          "TIAs are executed as cooperative agreements in accordance with the DoD Grant and Agreement Regulations (DoDGARs) – 32 CFR Part 21 when the government does not intend to deviate from the Bayh-Dole Act (35 U.S.C. Chapter 18  and 37 CFR Part 401) which permits a university, small business, or non-profit institution to pursue ownership of an invention made using government provided funds.",
          "Research OTs are used to execute TIAs when the government seeks to retain intellectual property rights that deviate from the Bayh-Dole Act.",
        ],
      },
      References: {
        FAR84: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/federal-supply-schedules/",
          "GSA Schedules: https":
            "//www.gsa.gov/buying-selling/purchasing-programs/gsa-schedule",
          "GSA Schedule BPAs":
            "https://www.gsa.gov/buying-selling/purchasing-programs/gsa-schedule/schedule-features/blanket-purchase-agreements",
          "GSA Multiple Award Schedule BPAs (Presentation)":
            "https://interact.gsa.gov/sites/default/files/PSHC%20SYMP%20-%20Understanding%20GSA%20Schedules%20BPAs%20_Final.pdf",
          "GSA Resources":
            "https://www.gsa.gov/buying-selling/purchasing-programs/gsa-schedule/we-are-here-to-help#BuyerResources",
        },
        FAR12: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/commercial-items/",
          "DFARS SubPart 212.102(a)(iii)":
            "https://www.acquisition.gov/dfars/212.102-applicability",
          "DPC Commercial Item Guidebook":
            "https://www.acq.osd.mil/dpap/cpic/cp/commercial_item_guide.html",
          "DCMA Commercial Item Group":
            "https://www.dcma.mil/Commercial-Item-Group/",
        },
        FAR13: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/simplified-acquisition-far-part-13/",
          "FAR Part 13.5": "https://www.acquisition.gov/far/13.500",
          "DPC Simplified Acquisition":
            " https://www.acq.osd.mil/dpap/ccap/cc/jcchb/HTML/Topical/simplified.html,",
        },
        FAR15: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/far-15/",
          "DoD Source Selection Procedures":
            "https://www.acq.osd.mil/dpap/policy/policyvault/USA004370-14-DPAP.pdf",
        },
        IDIQ: {
          "Contracting Cone": "https://aaf.dau.edu/aaf/contracting-cone/idiq/",
          "FAR 15.304(c)": "https://www.acquisition.gov/far/15.304",
          "FAR 16.505(b)(2)(i)(G)": "https://www.acquisition.gov/far/16.505",
        },
        FAR1603: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/letter-contract/",
          "DPC Letter Contracts":
            "https://www.acq.osd.mil/dpap/ccap/cc/jcchb/html/Topical/letter_contracts.html",
        },
        FAR167: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/agreements/",
          "Public Spend Forum - BOA vs BPA":
            "https://www.publicspendforum.net/blogs/frank-mcnally/2016/08/30/know-your-agreements-bpas-vs-boas/",
          "FAR SubPart 16.703 Basic Ordering Agreements":
            "https://www.acquisition.gov/far/16.703",
        },
        FAR19: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/small-business/",
          "DoD Office of Small Business": "https://business.defense.gov/",
        },
        BAA: {
          "Contracting Cone": "https://aaf.dau.edu/aaf/contracting-cone/baa/",
          "DARPA BAA Guide":
            "https://www.darpa.mil/attachments/DARPAGuideBAARA.pdf",
        },
        STTR: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/sbir-sttr/",
          "SBIR/STTR Programs": "https://www.sbir.gov/",
          "DoD SBIR/STTR":
            "https://rt.cto.mil/rtl-small-business-resources/sbir-sttr/",
        },
        CSO: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/defense-cso/",
          "CSO Program Memo":
            "https://www.acq.osd.mil/dpap/policy/policyvault/USA001228-18-DPAP.pdf",
          "GSA Procurement Innovation Resource Center (PIRC) CSO Guide":
            "https://www.gsa.gov/cdnstatic/PIRC%20CSO%20Guide%2062518.pdf",
        },
        OTS: {
          "Contracting Cone": "https://aaf.dau.edu/aaf/contracting-cone/ot/",
          "USD A&S Authority to Use Prototpye OTs Memo":
            "https://aaf.dau.edu/wp-content/uploads/2018/11/Authority-for-Use-of-Other-Transactions-for-Prototype-Projects-Under-10_....pdf",
          "USD A&S/R&E Requirements for Prototype OTs":
            "https://aaf.dau.edu/wp-content/uploads/2018/11/Definitions-and-Requirements-for-Other-Transactions-Under-Title-10_USC_S....pdf",
          "DoD OT Guide": "https://aaf.dau.edu/aaf/ot-guide/",
          "DARPA OT Resources": "https://acquisitioninnovation.darpa.mil/",
          "DCMA OT Price Evaluation":
            "https://www.dcma.mil/Portals/31/Documents/CIG/EvaluatingPrice_OtherTransactions(OTs)_V6.pdf",
          "DAU - Using OTs":
            "https://dauaa.org/wp-content/uploads/2018/04/DAU-Acq-Symposium-OT-briefing.pptx",
          "MITRE Other Transactions": "https://aida.mitre.org/ota/",
          "MITRE Existing Other Transaction Consortia":
            "https://aida.mitre.org/ota/existing-ota-consortia/",
        },
        EXPERIMENT: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/10usc2373/",
        },
        CRADA: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/rd-agreements/crada/",
          "Air Force Tech Transfer and Transition": "https://www.aft3.af.mil/",
          "Navy Tech Transfer Handbook":
            "https://www.onr.navy.mil/en/work-with-us/technology-transfer-t2/Partnership-Options/DON-T2-handbook",
          "NGA CRADA Handbook":
            "https://hallways.cap.gsa.gov/app/#/doclib?document=22990",
        },
        PIA: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/rd-agreements/pia/",
          "Air Force Tech Transfer and Transition": "https://www.aft3.af.mil/",
        },
        TIA: {
          "Contracting Cone":
            "https://aaf.dau.edu/aaf/contracting-cone/rd-agreements/tia/",
          "DARPA Sample TIAs":
            "https://acquisitioninnovation.darpa.mil/samples-and-resources/samples",
        },
      },
    };

    /***
     *
     * Approach Information
     *
     **/
    this.approachList = [
      "Oral Presentations",
      "Product or Technical Demonstration",
      "Advisory Down-Select",
      "Discovery",
      "Evaluate Innovation",
      "Qualified Bidders List",
      "Real Industry Communication",
      "Group Oral Debriefings",
      "Mission-Focused Evaluation Criteria",
      "Experience via Questions",
      "Affordability",
      "Phased Prototyping",
      "Video Proposals",
      "Skip Adjectival Ratings",
      "Risk-Based Contract Administration",
      "Iterative-Based Competition",
      "Stage-Based Competition",
      "Incentive Prize-Based Competition",
      "Challenge-Based Competition",
      "Milestone-Based",
    ];

    // *** Needs an updated script to pull this from csv automatically
    // *** Previous script invalid as file format changed considerably since this info was pulled
    // *** Info itself is current though
    this.tacticLookup = {
      Recommended: {
        "Oral Presentations": [
          "DO include on‐the‐spot questions (questions or exercises that offerors won’t see until the oral presentation begins).",
          "DO add a twist – interrupt their pitch with a particular scenario for them to address or wait until the end or their presentation if it is timed.",
          "DO consensus evaluation immediately following each offeror’s oral presentation.",
          "DO state that a firm may attend only one oral presentation, whether for itself as a prime offeror or as a subcontractor for another firm. DO eliminate" +
            "offerors via competitve range determination if the number of offerors is excessive.",
        ],
        "Multi-Phased Evaluations": [
          "Use multiple downselect gates to reduce wasted Gov't and industry resources, starting with the least amount of information needed for the evaluators to make a go/no-go" +
            "decision and asking for more detailed information subsequent rounds",
          "Use a confidence rating with a few supporting bullets to support the rating.",
        ],
        "Product or Technical Demonstration": [
          "DO use as either a stand‐alone factor or an element of the oral presentation.",
          "DO include a ‘test plan’ in the solicitation so industry knows what is being tested.",
          "DO ensure end‐users are included in the evaluation, as their feedback is crucial.",
          "DO pair with confidence level ratings.",
        ],
        "Advisory Down-Select": [
          "DO maintain 2‐3 vendors at the final phase to ensure a robust competition.",
          "DO use the most important factors to conduct the down-select, makes it higher impact.",
          "DO keep the factors planned for the down-select light so industry investment stays low.",
          "DO provide time between phases so offerors do not feel they must develop next‐phase proposals prior to receipt of down‐select notification.",
          "DO conduct in combination with use of confidence ratings, on‐the‐spot consensus, and oral presentations.",
        ],
        Discovery: [],
        "Evaluate Innovation": [
          "DO use a Statement of Objectives (SOO) instead of a Statement of Work (SOW) or Performance Work Statement  (PWS) to tell vendors the" +
            " Government's main concerns but allow maximum creativity from vendors in answering those concerns.",
          "DO incentivize innovation,  such as through evaluation criteria in the solicitation or written into the contract.",
        ],
        "Qualified Bidders List": ["TBD"],
        "Real Industry Communication": [
          "DO release drafts at 85% or better complete, even if you need to rework portions," +
            " so that vendors have a better understanding of the Govt's intentions.",
        ],
        "Group Oral Debriefings": [
          "DO consider providing some kind of feedback:  vendors need to know how to improve and they've sunk resources" +
            " into answering the solicitation. DO get permission from the winning vendor(s) to explain what the Govt liked about their proposal(s) w/o" +
            " giving away any proprietary information so that vendors understand better what the Govt is looking for.",
        ],
        "Mission-Focused Evaluation Criteria": ["TBD"],
        "Experience via Questions": ["TBD"],
        Affordability: ["TBD"],
        "Phased Prototyping": ["TBD"],
        "Video Proposals": ["TBD"],
        "Skip Adjectival Ratings": ["TBD"],
        "Risk-Based Contract Administration": ["TBD"],
        "Iterative-Based Competition": ["TBD"],
        "Stage-Based Competition": ["TBD"],
        "Incentive Prize-Based Competition": ["TBD"],
        "Challenge-Based Competition": ["TBD"],
        "Milestone-Based": ["TBD"],
      },
      NotRecommended: {
        "Oral Presentations": [
          "DON’T require the offeror to cover ALL aspects of the requirements document; rather, focus on the most important aspects and go into detail!",
          "DON’T leave ambiguity in the solicitation concerning rules or format for the orals.",
          "DON’T assume that you must videotape the presentation. We must have a record for the file, and FAR 15.102(e) lists several possibilities" +
            "(including videotaping) for the record.",
          "DON’T allow the offeror’s presenters to use electronics or phones for reach back.  DON'T duplicate work by asking for a detailed written" +
            "proposal and a detailed oral presentation.",
        ],
        "Multi-Phased Evaluations": [
          "DON'T use adjectival ratings that limit evaluators to a certain rating based on having a certain number of " +
            "strengths or weaknesses as this is not flexible and may overly restrict the evaluators’ ability to assign meaningful ratings.",
        ],
        "Product or Technical Demonstration": [
          "DON’T substitute the demonstration as the entirety of the technical proposal as there are other elements that will likely need to be considered.",
        ],
        "Advisory Down-Select": [
          "DON'T treat Advisory Down-Select as a substitute for Competitive Range Determination.  These are different and confusing " +
            "them will likely cause legal issues. Offerors do not have to honor the Advisory Down-Select although experience shows they most often do.",
          "DON'T provide formal debriefings based on an advisory down-select, although informal feedback after award may be advisable.",
        ],
        Discovery: ["TBD"],
        "Evaluate Innovation": ["TBD"],
        "Qualified Bidders List": ["TBD"],
        "Real Industry Communication": [
          "DON'T release draft sections that are riddled with errors or vague:  the intent is to get feedback, " +
            "not a have vendors write the solicitation for you.",
        ],
        "Group Oral Debriefings": ["TBD"],
        "Mission-Focused Evaluation Criteria": ["TBD"],
        "Experience via Questions": ["TBD"],
        Affordability: ["TBD"],
        "Phased Prototyping": ["TBD"],
        "Video Proposals": ["TBD"],
        "Skip Adjectival Ratings": ["TBD"],
        "Risk-Based Contract Administration": ["TBD"],
        "Iterative-Based Competition": ["TBD"],
        "Stage-Based Competition": ["TBD"],
        "Incentive Prize-Based Competition": ["TBD"],
        "Challenge-Based Competition": ["TBD"],
        "Milestone-Based": ["TBD"],
      },
    };

    this.approachDescriptions = require("../dataIngest/approach/approach.json");

    // *** Needs an updated script to pull this from csv automatically
    // *** Previous script invalid as file format changed considerably since this info was pulled
    // *** Info itself is current though
    /*
    this.approachDescriptions = {
     
      "Oral Presentations":
        "Allows the program technical staff to see and hear proposed solutions from the team that would perform the work which provides a much more in-depth " +
        "perspective of the proposed offer. Provides greater confidence the company knows the technical requirement.  According to FAR 15.102(a): “Oral presentations " +
        'provide an opportunity for dialogue among the parties."',
      "Multi-Phased Evaluations":
        "Narrow down the number of offerors to evaluate ideally 2–3 offers for every anticipated award in order to maximize each offeror’s Probability of Win " +
        "(pWin). This helps minimize controversy and re‐work in the team's internal review processes. You can use confidence ratings in acquisitions under FAR" +
        "subpart 8.4 (orders/BPAs against schedule contracts), part 13 (Simplified Acquisitions), subpart 15.3 (source selections), and § 16.505 (fair opportunity " +
        "for orders under multiple‐award IDIQ contracts).",

      "Product or Technical Demonstration":
        "To see, feel, and test out a product/system before the government buys them.  This technique can help reveal a companies’ true capabilities." +
        "They can also streamline the selection process and lower bid and proposal costs.",

      "Advisory Down-Select":
        "Notify low-rated offerors that they have little chance to receive an award before they submit detailed technical and price proposals. If those non-competitive " +
        "offerors self-select out of the competition,there are many benefits:  they have no standing to file a protest; it reduces industry costs and burden to industry; " +
        "it reduces the amount of documentation for the Government to review, and it improves the final trade-off decisions.",

      Discovery:
        "Ensure prospective offerors fully understand requirements before submitting full proposals and allow offerors ask questions about the requirements and the “as-is” " +
        " operational landscape during a discovery session.",

      "Evaluate Innovation":
        "Incentivize industry to incorporate innovation into its proposed product or service by asking questions relevant to innovation during proposal submission, and ensuring" +
        "innovation is included in the evaluation factors so industry knows they will receive credit for their ideas.",

      "Qualified Bidders List":
        "To avoid receiving unqualified proposals, use this Federal Acquisition Regulation (FAR) subpart 9.2 technique.",

      "Real Industry Communication":
        "Release draft requests for proposal with Sections B, C, L, and M to get early feedback, communicate desired objectives, and maintain communication throughout your acquisition!",

      "Group Oral Debriefings":
        "Too many offerors to give oral debriefings? Don’t give up. Consider group oral debriefing(s) in addition to individual written debriefings. OMB’s “Myth-busting 3” memo highlights this approach.",

      "Mission-Focused Evaluation Criteria":
        "Make sure your evaluation criteria focus on specific mission outcomes and challenging areas of performance, including innovation—this really differentiates among the offerors.",

      "Experience via Questions":
        "Make experience as a technical evaluation factor more meaningful by asking questions! Use your mission to provide context and ask targeted questions about the " +
        "offeror’s related experience. For example: “Describe your experience working with large quantities of data from a variety of sources.”",

      Affordability:
        "Consider giving vendors a target price or a narrow price range to reduce gamesmanship in the bid and proposal process. For example, if the Independent Government Cost Estimate " +
        "is $75M, consider posting a range of $70M–$80M in the solicitation. The government can select a vendor with a price under, in between, or over the target or range like any " +
        "best value tradeoff.",

      "Phased Prototyping":
        "Use options to prototype and test a solution. If the solution proves successful, exercise an option for a low rate of initial production, and even one for the full rate " +
        "of production items. User feedback during prototyping and testing with awardees is crucial to this innovation.",

      "Video Proposals":
        "Have the offeror use a smartphone to record a quick 10-minute video of themselves talking about one technical factor and then have them upload it to YouTube for the government " +
        "to evaluate. It saves time and is great for down-selects!",

      "Skip Adjectival Ratings":
        "Stay in the correct FAR lane and document accordingly. Where appropriate, skip adjectival ratings, and document the comparative evaluation.",
      "Risk-Based Contract Administration":
        "Prioritize resources to high-risk activities and explore ways to manage low-risk activities.",

      "Iterative-Based Competition":
        "Involves issuance of several contracts for small, inexpensive prototypes to be built within a short period and then tested in relevant demonstration scenarios to " +
        "assess the viability of each before making a substantial investment.",

      "Stage-Based Competition":
        "Utilizes short concept papers to enable agencies to identify vendors who are most likely to receive an award and to help those who are less likely to receive an award " +
        "avoid the cost of developing a detailed proposal.",

      "Incentive Prize-Based Competition":
        "Uses the authorities provided by the America COMPETES Reauthorization Act of 2010 to enable an agency to run a competition where the winner receives a prize " +
        "for developing a viable solution to solve a government need.",

      "Challenge-Based Competition":
        "Designed to explore the market and pay only for a successful solution.  Geared towards projects where solutions are likely to already exist as opposed to having " +
        "to be developed. The key differentiator between challenge-based acquisition and a traditional performance-based acquisition is the firm requirement to demonstrate " +
        "product performance in real-world conditions prior to a major commitment of resources for full production.",

      "Milestone-Based":
        "Involves the issuance of task orders for a series of clear, technically feasible milestones, each with an assigned deadline and monetary value with a qualified pool of contractors.",
    
      };
      */
    /***
     *
     * Tailoring Information
     *
     **/

    this.newMCA1 = {
      Statutory: {},
      Exceptions: {},
      Regulatory: {},
    };

    // Deprecated
    // this.tailoringDescriptions = require("../dataIngest/Tailoring/data.json");

    this.MCA1_Tailoring = require("../dataIngest/Tailoring/MCA_ACAT_I.json");
    this.MCA2_Tailoring = require("../dataIngest/Tailoring/MCA_ACAT_II.json");
    this.MCA3_Tailoring = require("../dataIngest/Tailoring/MCA_ACAT_III.json");

    this.DBS_Tailoring = require("../dataIngest/Tailoring/DBS_ACAT_I.json");

    this.MTARF1_Tailoring = require("../dataIngest/Tailoring/MTA RF_ACAT_I.json");
    this.MTARF2_Tailoring = require("../dataIngest/Tailoring/MTA RF_ACAT_II.json");
    this.MTARF3_Tailoring = require("../dataIngest/Tailoring/MTA RF_ACAT_III.json");

    this.MTARP1_Tailoring = require("../dataIngest/Tailoring/MTA RP_ACAT_I.json");
    this.MTARP2_Tailoring = require("../dataIngest/Tailoring/MTA RP_ACAT_II.json");
    this.MTARP3_Tailoring = require("../dataIngest/Tailoring/MTA RP_ACAT_III.json");

    this.SWP1_Tailoring = require("../dataIngest/Tailoring/SWP_ACAT_I.json");
    this.SWP2_Tailoring = require("../dataIngest/Tailoring/SWP_ACAT_II.json");
    this.SWP3_Tailoring = require("../dataIngest/Tailoring/SWP_ACAT_III.json");

    this.UCA2_Tailoring = require("../dataIngest/Tailoring/UCA_ACAT_II.json");
    this.UCA3_Tailoring = require("../dataIngest/Tailoring/UCA_ACAT_III.json");

    /***
     *
     * User Choice Information -
     *    Bools for each contract, approach, and tailoring option
     *
     **/
    this.contractChoice = {};

    this.approachChoice = {
      "Oral Presentations": false,
      "Product or Technical Demonstration": false,
      "Advisory Down-Select": false,
      Discovery: false,
      "Evaluate Innovation": false,
      "Qualified Bidders List": false,
      "Real Industry Communication": false,
      "Group Oral Debriefings": false,
      "Mission-Focused Evaluation Criteria": false,
      "Experience via Questions": false,
      Affordability: false,
      "Phased Prototyping": false,
      "Video Proposals": false,
      "Skip Adjectival Ratings": false,
      "Risk-Based Contract Administration": false,
      "Iterative-Based Competition": false,
      "Stage-Based Competition": false,
      "Incentive Prize-Based Competition": false,
      "Challenge-Based Competition": false,
      "Milestone-Based": false,
    };
  }

  /***
   *
   * Setters
   *
   **/
  setName(nameVal) {
    this.projectName = nameVal;
  }

  setNature(nature) {
    this.projectNature = nature;
  }

  setUrgency(bool) {
    this.urgency = bool;
  }

  setDBS(bool) {
    this.DBS = bool;
  }

  setCosts(costs) {
    this.EstCosts = costs;
  }

  setApproach(bool, approach) {
    this.approachChoice[approach] = bool;
  }

  setPathway(pathway) {
    this.pathwayChoice = pathway;
  }

  setContract(bool, approach) {
    this.contractChoice[approach] = bool;
  }

  setTailoring(bool, approach, group) {
    this.tailoringChoice[group][approach] = bool;
  }

  /***
   *
   * Getters
   *
   **/
  getUrgency() {
    return this.urgency;
  }

  getDBS() {
    return this.DBS;
  }

  getScenario() {
    return this.scenarioChoice;
  }

  getRecPaths() {
    return this.yesPathways;
  }

  getNoRecPaths() {
    return this.noPathways;
  }

  getNAPaths() {
    return this.NAPathways;
  }

  getNatureDescription() {
    return this.natureDescriptions[this.projectNature];
  }

  getFullPathwayName() {
    return this.fullPathwayNames[this.pathwayChoice];
  }

  getContractChoice() {
    return this.fullContractNames[this.contractChoice];
  }

  getContractRecommendations() {
    return this.contractRecommendation;
  }

  getContractsNotRecommended() {
    return this.contractNotRecommended;
  }

  getGeneralTips() {
    switch (this.pathwayChoice) {
      case "MCA":
        return this.MCATips;
      case "UCA":
        return this.UCATips;
      case "RapidFielding":
        return this.MTA_RFTips;
      case "RapidPrototyping":
        return this.MTA_RPTips;
      case "DBS":
        return this.DBSTips;
      case "SWP":
        return this.SWPTips;
      case "AOS":
        return this.AOSTips;
      default:
        return this.UCATips;
    }
  }

  getTailoringChoice() {
    switch (this.pathwayChoice) {
      case "MCA":
        if (this.EstCosts === "ACAT I") {
          return this.MCA1_Tailoring;
        } else if (this.EstCosts === "ACAT II") {
          return this.MCA2_Tailoring;
        } else if (this.EstCosts === "ACAT III") {
          return this.MCA3_Tailoring;
        }
        break;
      case "UCA":
        if (this.EstCosts === "ACAT II") {
          return this.UCA2_Tailoring;
        } else if (this.EstCosts === "ACAT III") {
          return this.UCA3_Tailoring;
        }
        break;
      case "RapidFielding":
        if (this.EstCosts === "ACAT I") {
          return this.MTARF1_Tailoring;
        } else if (this.EstCosts === "ACAT II") {
          return this.MTARF2_Tailoring;
        } else if (this.EstCosts === "ACAT III") {
          return this.MTARF3_Tailoring;
        }
        break;
      case "RapidPrototyping":
        if (this.EstCosts === "ACAT I") {
          return this.MTARP1_Tailoring;
        } else if (this.EstCosts === "ACAT II") {
          return this.MTARP2_Tailoring;
        } else if (this.EstCosts === "ACAT III") {
          return this.MTARP3_Tailoring;
        }
        break;
      case "DBS":
        return this.DBS_Tailoring;
      case "SWP":
        if (this.EstCosts === "ACAT I") {
          return this.SWP1_Tailoring;
        } else if (this.EstCosts === "ACAT II") {
          return this.SWP2_Tailoring;
        } else if (this.EstCosts === "ACAT III") {
          return this.SWP3_Tailoring;
        }
        break;
      case "AOS":
        if (this.EstCosts === "ACAT I") {
          return this.MCA1_Tailoring;
        } else if (this.EstCosts === "ACAT II") {
          return this.MCA2_Tailoring;
        } else if (this.EstCosts === "ACAT III") {
          return this.MCA3_Tailoring;
        }
        break;
      default:
        if (this.EstCosts === "ACAT I") {
          return this.MCA1_Tailoring;
        } else if (this.EstCosts === "ACAT II") {
          return this.MCA2_Tailoring;
        } else if (this.EstCosts === "ACAT III") {
          return this.MCA3_Tailoring;
        } else {
          return this.MCA1_Tailoring;
        }
    }
  }

  getUrgencyText() {
    if (this.urgency) {
      return "Yes";
    } else {
      return "No";
    }
  }

  getDBSText() {
    if (this.DBS) {
      return "Yes";
    } else {
      return "No";
    }
  }

  createTailoringChoices() {
    if (this.EstCosts !== "") {
      let choicesDict = { Statutory: {}, Exception: {}, Regulatory: {} };
      let allTailoring = this.getTailoringChoice();

      let allOptions = {
        Statutory: Object.keys(allTailoring["Statutory"]),
        Exception: Object.keys(allTailoring["Exception"]),
        Regulatory: Object.keys(allTailoring["Regulatory"]),
      };

      Object.keys(allOptions).forEach((grouping) => {
        let cur_group = allOptions[grouping];
        cur_group.forEach((name) => {
          if (grouping === "Statutory") {
            choicesDict[grouping][name] = true;
          } else {
            choicesDict[grouping][name] = false;
          }
        });
      });

      this.tailoringChoice = choicesDict;
    }

    /*
    
    let tailoringAvailable = this.getTailoringChoice();
    let allOptions = {
      Statutory: Object.keys(tailoringAvailable["Statutory"]),
      Exception: Object.keys(tailoringAvailable["Exception"]),
      Regulatory: Object.keys(tailoringAvailable["Regulatory"]),
    };
    Object.keys(allOptions).forEach((grouping) => {
      
      Object.keys(allOptions[grouping]).forEach((name) => {
        if (grouping === "Statutory") {
          
          choicesDict[grouping][allOptions[name]] = true;
        } else {
          choicesDict[grouping][allOptions[name]] = false;
        }
      });
    });
    
    
    this.tailoringOptions = allOptions;
    this.tailoringChoice = choicesDict;
    */
  }

  /**
   * Determines scenario grouping, pathway, and contract recommendations.
   * Called upon completion of entry form for tool.
   * {@link determineContractRecommendation}
   * {@link determineScenarioGroup}
   * {@link determinePathways}
   */
  applyChoices() {
    this.determineScenarioGroup();
    this.determinePathways();
    this.determineContractRecommendation();
  }
  /**
   *
   * Sets the scenario group and specific scenario choice
   * based on project nature and ACAT level.
   * {@link determineGroup3}
   * {@link determineGroup4}
   * {@link determineGroup5}
   * {@link determineGroup6}
   *
   */
  determineScenarioGroup() {
    if (this.projectNature !== "" && this.EstCosts !== "") {
      if (this.projectNature === "NAT1") {
        this.scenarioGroup = 1;
        if (this.EstCosts === "ACAT I") {
          this.scenarioChoice = 1;
        } else if (this.EstCosts === "ACAT II") {
          this.scenarioChoice = 2;
        } else if (this.EstCosts === "ACAT III") {
          this.scenarioChoice = 3;
        }
      } else if (this.projectNature === "NAT2") {
        this.scenarioGroup = 2;
        if (this.EstCosts === "ACAT I") {
          this.scenarioChoice = 4;
        } else if (this.EstCosts === "ACAT II") {
          this.scenarioChoice = 5;
        } else if (this.EstCosts === "ACAT III") {
          this.scenarioChoice = 6;
        }
      } else if (this.projectNature === "NAT3") {
        this.scenarioGroup = 3;
        this.determineGroup3();
      } else if (this.projectNature === "NAT4") {
        this.scenarioGroup = 4;
        this.determineGroup4();
      } else if (this.projectNature === "NAT5") {
        this.scenarioGroup = 5;
        this.determineGroup5();
      } else {
        this.scenarioGroup = 6;
        this.determineGroup6();
      }
    }
  }
  /**
   * Scenario determination for group 3
   */
  determineGroup3() {
    switch (this.EstCosts) {
      case "ACAT I":
        if (this.DBS) {
          this.scenarioChoice = 12;
        } else {
          this.scenarioChoice = 7;
        }
        break;
      case "ACAT II":
        if (this.urgency) {
          this.scenarioChoice = 10;
        } else if (this.DBS) {
          this.scenarioChoice = 13;
        } else {
          this.scenarioChoice = 8;
        }
        break;
      case "ACAT III":
        if (this.urgency) {
          this.scenarioChoice = 11;
        } else if (this.DBS) {
          this.scenarioChoice = 14;
        } else {
          this.scenarioChoice = 9;
        }
        break;
      default:
        this.scenarioChoice = 0;
    }
  }
  /**
   * Scenario determination for group 4
   */
  determineGroup4() {
    switch (this.EstCosts) {
      case "ACAT I":
        this.scenarioChoice = 15;
        break;
      case "ACAT II":
        if (this.urgency) {
          this.scenarioChoice = 18;
        } else {
          this.scenarioChoice = 16;
        }
        break;
      case "ACAT III":
        if (this.urgency) {
          this.scenarioChoice = 19;
        } else {
          this.scenarioChoice = 17;
        }
        break;
      default:
        this.scenarioChoice = 0;
    }
  }

  /**
   * Scenario determination for group 5
   */
  determineGroup5() {
    switch (this.EstCosts) {
      case "ACAT I":
        this.scenarioChoice = 20;
        break;
      case "ACAT II":
        if (this.urgency) {
          this.scenarioChoice = 23;
        } else {
          this.scenarioChoice = 21;
        }
        break;
      case "ACAT III":
        if (this.urgency) {
          this.scenarioChoice = 24;
        } else {
          this.scenarioChoice = 22;
        }
        break;
      default:
        this.scenarioChoice = 0;
    }
  }
  /**
   * Scenario determination for group 6
   */
  determineGroup6() {
    switch (this.EstCosts) {
      case "ACAT I":
        if (this.DBS) {
          this.scenarioChoice = 30;
        } else {
          this.scenarioChoice = 25;
        }
        break;
      case "ACAT II":
        if (this.urgency) {
          this.scenarioChoice = 28;
        } else if (this.DBS) {
          this.scenarioChoice = 31;
        } else {
          this.scenarioChoice = 26;
        }
        break;
      case "ACAT III":
        if (this.urgency) {
          this.scenarioChoice = 29;
        } else if (this.DBS) {
          this.scenarioChoice = 32;
        } else {
          this.scenarioChoice = 27;
        }
        break;
      default:
        this.scenarioChoice = 0;
    }
  }
  /**
   * Determines applicable pathways based on scenario choice
   */
  determinePathways() {
    this.yesPathways = [];
    this.noPathways = [];
    this.NAPathways = [];
    if (this.scenarioChoice) {
      this.yesPathways = this.pathwayDict[this.scenarioChoice]["Yes"];
      this.noPathways = this.pathwayDict[this.scenarioChoice]["No"];
      this.NAPathways = this.pathwayDict[this.scenarioChoice]["NA"];
    }
  }
  /**
   * @param  {string} name Member variable being modified
   * @param  {string} val New value for the member variable specified
   *
   * Updates member variables based on entry form selections.
   */
  updateContext(name, val) {
    if (name[0] === "projectName") {
      this.projectName = val[0];
    } else if (name[0] === "projectNature") {
      this.projectNature = val[0];
      if (val[0] === "NAT1" || val[0] === "NAT2") {
        this.urgency = false;
        this.DBS = false;
      } else if (val[0] === "NAT4" || val[0] === "NAT5") {
        this.DBS = false;
      }
    } else if (name[0] === "EstCosts") {
      this.EstCosts = val[0];

      if (val === "ACAT I") {
        this.urgency = false;
      }
    } else if (name[0] === "pathwayChoice") {
      this.pathwayChoice = val[0];
    }
  }
  /**
   * Checks to see if urgency option is disabled based on entry form selections
   */
  checkUrgencyDisabled() {
    //
    if (
      this.EstCosts === "ACAT I" ||
      this.DBS ||
      this.projectNature === "NAT1" ||
      this.projectNature === "NAT2"
    ) {
      return true;
    }
    return false;
  }
  /**
   * Checks to see if DBS option is disabled based on entry form selections
   */
  checkDBSDisabled() {
    //
    if (
      this.urgency ||
      this.projectNature === "NAT1" ||
      this.projectNature === "NAT2" ||
      this.projectNature === "NAT4" ||
      this.projectNature === "NAT5"
    ) {
      return true;
    }
    return false;
  }
  /**
   * @param  {stirng} path pathway to check if recommended
   * Checks to see if a pathway is recommended based on entry form selections
   */
  isRecommended(path) {
    if (this.yesPathways.includes(path)) {
      return true;
    }
    return false;
  }

  /**
   * @param  {string} path pathway to check if applicable
   * Checks to see if a pathway is applicable based on entry form selections
   */

  isNotApplicable(path) {
    if (this.NAPathways.includes(path)) {
      return true;
    }
    return false;
  }
  /**
   * @param  {string} contract name of contract to find associated links
   * @returns links associated with the contract
   *
   * Looksup applicable links for a given contract
   */
  contractLinkLookup(contract) {
    switch (contract) {
      case "FAR12":
        return "https://aaf.dau.edu/aaf/contracting-cone/commercial-items/";
      default:
        return "";
    }
  }
  /**
   * Determines recomended contracts and updates contractRecommendation array
   */
  determineContractRecommendation() {
    for (const contract of this.contractNames) {
      if (
        this.contractInformation[contract]["RECOMMENDED FOR SCENARIOS"].find(
          (a) => a.includes(this.scenarioGroup)
        )
      ) {
        this.contractRecommendation.push(contract);
      } else {
        this.contractNotRecommended.push(contract);
      }
      this.contractChoice[contract] = false;
    }

    /*
    switch (this.scenarioGroup) {
      case 1:
        this.contractRecommendation = [
          "FAR12",
          "FAR13",
          "BAA",
          "STTR",
          "CSO",
          "OTS",
          "EXPERIMENT",
        ];
        break;
      case 2:
        this.contractRecommendation = [
          "FAR12",
          "BAA",
          "STTR",
          "CSO",
          "OTS",
          "EXPERIMENT",
        ];
        break;
      case 3:
        this.contractRecommendation = [
          "FAR12",
          "FAR13",
          "FAR15",
          "IDIQ",
          "FAR19",
        ];
        break;
      case 4:
        this.contractRecommendation = ["FAR15", "IDIQ", "OTS"];
        break;
      case 5:
        this.contractRecommendation = [
          "FAR12",
          "FAR13",
          "FAR15",
          "IDIQ",
          "FAR19",
        ];
        break;
      case 6:
        this.contractRecommendation = ["FAR12", "FAR13", "IDIQ", "FAR19"];
        break;
      default:
        this.contractRecommendation = [];
    }
    for (var i = 0; i < 16; i++)
      if (!this.contractRecommendation.includes(this.contractAbbrev[i])) {
        this.contractNotRecommended.push(this.contractAbbrev[i]);
      }
  */
  }
}

export default PactUser;
